import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ControlSpecification } from '../types/specification.types';
import { AbstractControl } from '../types/control.types';

@Injectable()
export class DragService {
  // æå¨äºä»¶
  private dragEventSubject: Subject<DragEvent>;
  // æå¨å°çç»æçæ§ä»¶ä¸
  private dragEndAtControlSubject: Subject<AbstractControl<any> | any>;
  // æå¨ç»æ
  private dragEndSubject: Subject<ControlSpecification>;
  constructor() {
    this.dragEventSubject = new Subject<DragEvent>();
    this.dragEndAtControlSubject = new Subject<AbstractControl<any> | any>();
    this.dragEndSubject = new Subject<ControlSpecification>();
  }

  // åéæå¨äºä»¶
  sendDragEvent(event: DragEvent) {
    this.dragEventSubject.next(event);
  }
  get dragEvent$(): Observable<DragEvent> {
    return this.dragEventSubject.asObservable();
  }

  // åéæå¨ç»æå¨é£ä¸ªæ§ä»¶ä¸äºä»¶
  sendDragEndAtControl(event: AbstractControl<any> | any) {
    this.dragEndAtControlSubject.next(event);
  }
  get dragEndAtControl$(): Observable<AbstractControl<any> | any> {
    return this.dragEndAtControlSubject.asObservable();
  }

  // åéæå¨ç»æäºä»¶
  sendDragEnd(event: ControlSpecification) {
    this.dragEndSubject.next(event);
  }
  get dragEnd$(): Observable<ControlSpecification> {
    return this.dragEndSubject.asObservable();
  }
}

export interface DragEvent {
  eventType: DragEventType;
  specification?: ControlSpecification;
  offset?: { x: number; y: number };
}

export enum DragEventType {
  Begin,
  Draging,
  End
}
